import FixedLangSwitcher from "components/FixedLangSwitcher/FixedLangSwitcher";
import InsCGUBar from "components/InsCGUBar/InsCGUBar";
import useGuestGuard from "hooks/useGuestGuard.js";
import { SentryRoute } from "index.js";
import Cgu from "pages/App/Cgu/Cgu";
import React from "react";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import Create from "./Create/Create.jsx";
import CreateSuccess from "./CreateSuccess/CreateSuccess";
import ForgetPassword from "./ForgetPassword/ForgetPassword";
import Intro from "./Intro/Intro";
import Login from "./Login/Login";
import TeamsSSO from "./Login/TeamsSSO";
import NewPassword from "./NewPassword/NewPassword";
import ResetPassword from "./ResetPassword/ResetPassword";

const GuestSwitch = () => {
  useGuestGuard();
  const location = useLocation();
  const match = useRouteMatch();

  return (
    <Switch location={location}>
      <SentryRoute exact path={`${match.path}/login`} component={Login} />
      <SentryRoute exact path={`${match.path}/teams`} component={TeamsSSO} />
      <SentryRoute exact path={`${match.path}/create`} component={Create} />
      <SentryRoute
        exact
        path={`${match.path}conditions-generales-utilisation`}
        component={Cgu}
      />
      <SentryRoute
        exact
        path={`${match.path}/create-success`}
        component={CreateSuccess}
      />
      <SentryRoute
        exact
        path={`${match.path}/forget-password`}
        component={ForgetPassword}
      />
      <SentryRoute
        exact
        path={`${match.path}/re-engagement/:id`}
        component={Intro}
      />
      <SentryRoute exact path={`${match.path}`} component={Intro} />
    </Switch>
  );
};

const ConnectSwitch = () => {
  const location = useLocation();
  const match = useRouteMatch();

  return (
    <>
      <section className="route-section">
        <div className="route-section-inner">
          <Switch location={location}>
            <SentryRoute
              exact
              path={`${match.path}/new-password`}
              component={NewPassword}
            />
            <SentryRoute
              exact
              path={`${match.path}/reset-password/:token`}
              component={ResetPassword}
            />
            <SentryRoute>
              <GuestSwitch />
            </SentryRoute>
          </Switch>
        </div>
        <InsCGUBar location={location} />
        <div className="lang-switcher-wrapper">
          <FixedLangSwitcher />
        </div>
      </section>
    </>
  );
};

export default ConnectSwitch;
